var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#7A7A7A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M195.982 21.152c1.426-1.859 1.164-4.505-.599-6.05-1.763-1.543-4.422-1.456-6.08.2-1.657 1.657-1.745 4.315-.2 6.077 1.546 1.761 4.193 2.023 6.054.598l3.856 3.854c.226.225.592.225.818 0 .225-.226.225-.591 0-.817l-3.849-3.862zm-3.517.586c-1.81 0-3.277-1.466-3.277-3.275 0-1.81 1.467-3.276 3.277-3.276s3.278 1.466 3.278 3.276c-.004 1.807-1.47 3.271-3.278 3.275z",
    transform: "translate(-444 -361) translate(220 202) translate(36 145)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.592338231e32ca3968506c4f65c70e05.svg";
export { ForwardRef as ReactComponent };